app.controller('eWaybillPrefixMasterCtrl', function ($scope, urlServices, toaster, modalService, modalFactory) {
    var apiBase = 'api/e-waybill-numbering-masters';

    function createPrefixForm() {
        return {
            id: 0,
            marketingCode: '',
            totalCustomer: 0,
            prefix: '',
            description: '',
            stageOneDigits: 4,
            stageTwoAlphaLength: 1,
            stageTwoDigits: 3,
            stageThreeAlphaLength: 2,
            stageThreeDigits: 2,
            isActive: true
        };
    }

    function normalizeTextValue(value) {
        if (value === undefined || value === null) {
            return '';
        }

        return String(value).trim();
    }

    function normalizePrefixValue(value) {
        return normalizeTextValue(value).toUpperCase().replace(/\s+/g, '').slice(0, 5);
    }

    function buildErrorMessage(err, fallbackMessage) {
        if (!err) {
            return fallbackMessage;
        }
        if (err.err) {
            return err.err;
        }
        if (err.message) {
            return err.message;
        }

        return err;
    }

    function normalizeRows(result) {
        return (result || []).map(function (row) {
            row.isActive = row.isActive !== false;
            return row;
        });
    }

    function resetPrefixForm() {
        $scope.prefixForm = createPrefixForm();
    }

    function applyResolvedMarketingCode(result) {
        var resolved = result || {};

        $scope.prefixForm.marketingCode = resolved.marketingCode || '';
        $scope.prefixForm.totalCustomer = Number(resolved.totalCustomer || 0);
        $scope.prefixForm.prefix = normalizePrefixValue(resolved.prefix || '');
        if (!$scope.prefixForm.description) {
            $scope.prefixForm.description = resolved.marketingCode || '';
        }
    }

    function resolveMarketingCodeData(marketingCode) {
        var normalizedMarketingCode = normalizeTextValue(marketingCode).toUpperCase();

        $scope.prefixForm.marketingCode = normalizedMarketingCode;
        if (!normalizedMarketingCode) {
            $scope.prefixForm.totalCustomer = 0;
            return null;
        }

        $scope.prefixResolvingMarketingCode = true;
        return urlServices.ambilData(apiBase + '/marketing-code/' + encodeURIComponent(normalizedMarketingCode), {}, function (err, result) {
            $scope.prefixResolvingMarketingCode = false;
            if (err) {
                $scope.prefixForm.totalCustomer = 0;
                return toaster.pop('error', 'Master Management', buildErrorMessage(err, 'Gagal mengambil data marketing code'));
            }

            applyResolvedMarketingCode(result);
        });
    }

    $scope.prefixRows = [];
    $scope.prefixLoading = false;
    $scope.prefixSaving = false;
    $scope.prefixResolvingMarketingCode = false;
    $scope.prefixFilter = '';
    $scope.prefixForm = createPrefixForm();

    $scope.loadPrefixMasters = function () {
        $scope.prefixLoading = true;
        return urlServices.ambilData(apiBase + '?include_inactive=1', {}, function (err, result) {
            $scope.prefixLoading = false;
            if (err) {
                return toaster.pop('error', 'Master Management', buildErrorMessage(err, 'Gagal memuat master prefix e-waybill'));
            }

            $scope.prefixRows = normalizeRows(result);
        });
    };

    $scope.openMarketingCodeLookup = function () {
        return modalService.showModal({}, {
            closeButtonText: 'Batal',
            actionButtonText: 'Pilih',
            headerText: 'Pilih Marketing Code',
            bodyText: 'Gunakan popup untuk memilih marketing code.'
        }).then(function () {
            // Placeholder for actual modal logic if modalFactory is used elsewhere
        });
    };

    $scope.openMarketingCodeLookup = function () {
        return modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
            functionName: 'marketingCodeList',
            params: {}
        });
    };

    $scope.$on('pilih-marketing-code', function (event, args) {
        if (args) {
            $scope.prefixForm.marketingCode = normalizeTextValue(args.MarketingCode || args.marketing_code).toUpperCase();
            $scope.resolveSelectedMarketingCode();
        }
    });

    $scope.editPrefixMaster = function (row) {
        $scope.prefixForm = {
            id: row.id || 0,
            marketingCode: row.marketingCode || '',
            totalCustomer: row.totalCustomer || 0,
            prefix: normalizePrefixValue(row.prefix || ''),
            description: row.description || '',
            stageOneDigits: row.stageOneDigits || 4,
            stageTwoAlphaLength: row.stageTwoAlphaLength || 1,
            stageTwoDigits: row.stageTwoDigits || 3,
            stageThreeAlphaLength: row.stageThreeAlphaLength || 2,
            stageThreeDigits: row.stageThreeDigits || 2,
            isActive: row.isActive !== false
        };
    };

    $scope.cancelPrefixMaster = function () {
        resetPrefixForm();
    };

    $scope.resolveSelectedMarketingCode = function () {
        return resolveMarketingCodeData($scope.prefixForm.marketingCode);
    };

    $scope.clearSelectedMarketingCode = function () {
        $scope.prefixForm.marketingCode = '';
        $scope.prefixForm.totalCustomer = 0;
        $scope.prefixForm.prefix = '';
    };

    $scope.savePrefixMaster = function () {
        var payload = {
            id: $scope.prefixForm.id || 0,
            marketingCode: normalizeTextValue($scope.prefixForm.marketingCode).toUpperCase(),
            prefix: normalizePrefixValue($scope.prefixForm.prefix),
            description: normalizeTextValue($scope.prefixForm.description),
            stageOneDigits: $scope.prefixForm.stageOneDigits || 4,
            stageTwoAlphaLength: $scope.prefixForm.stageTwoAlphaLength || 1,
            stageTwoDigits: $scope.prefixForm.stageTwoDigits || 3,
            stageThreeAlphaLength: $scope.prefixForm.stageThreeAlphaLength || 2,
            stageThreeDigits: $scope.prefixForm.stageThreeDigits || 2,
            isActive: $scope.prefixForm.isActive ? 1 : 0
        };
        var requestMethod = payload.id ? urlServices.updateData : urlServices.simpanData;

        if (!payload.marketingCode) {
            return toaster.pop('warning', 'Master Management', 'Marketing code wajib dipilih');
        }
        if (!payload.prefix) {
            return toaster.pop('warning', 'Master Management', 'Prefix e-waybill wajib diisi');
        }

        $scope.prefixSaving = true;
        return requestMethod(apiBase, payload, function (err, result) {
            $scope.prefixSaving = false;
            if (err) {
                return toaster.pop('error', 'Master Management', buildErrorMessage(err, 'Gagal menyimpan master prefix e-waybill'));
            }

            $scope.prefixRows = normalizeRows(result && result.items ? result.items : $scope.prefixRows);
            resetPrefixForm();
            toaster.pop('success', 'Master Management', 'Master prefix e-waybill berhasil disimpan');
            if (!(result && result.items)) {
                $scope.loadPrefixMasters();
            }
        });
    };

    $scope.deletePrefixMaster = function (row) {
        modalService.showModal({}, {
            closeButtonText: 'No',
            actionButtonText: 'Yes',
            headerText: 'Hapus Master Prefix',
            bodyText: 'Hapus master prefix marketing code ' + (row.marketingCode || '-') + '?'
        }).then(function (confirmed) {
            if (!confirmed) {
                return;
            }

            return urlServices.hapusData(apiBase + '/' + encodeURIComponent(row.id), {}, function (err, result) {
                if (err) {
                    return toaster.pop('error', 'Master Management', buildErrorMessage(err, 'Gagal menghapus master prefix e-waybill'));
                }

                if (Number($scope.prefixForm.id || 0) === Number(row.id || 0)) {
                    resetPrefixForm();
                }
                $scope.prefixRows = normalizeRows(result && result.items ? result.items : $scope.prefixRows);
                toaster.pop('success', 'Master Management', 'Master prefix e-waybill berhasil dihapus');
                if (!(result && result.items)) {
                    $scope.loadPrefixMasters();
                }
            });
        });
    };

    resetPrefixForm();
    $scope.loadPrefixMasters();
});